import { Container, Section } from "@/components/ui/section";

const steps = [
  {
    number: "1",
    title: "Choose or customize an interview flow",
    description: "Templates for case studies, customer stories, user stories, win/loss, or product feedback."
  },
  {
    number: "2",
    title: "Invite your customers",
    description: "Share a link, email invitations, or embed Casey in your product. No scheduling needed."
  },
  {
    number: "3",
    title: "Approve and publish assets",
    description: "Review transcripts, approve generated stories, and publish/export to CMS, CRM, or docs."
  }
];

export const HowItWorks = () => {
  return (
    <Section id="how-it-works" className="bg-muted/20">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
            How Casey works
          </h2>
          <p className="text-lg text-muted-foreground">
            From "we should talk to our customers more" to "we have a steady stream of stories and insights."
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative flex">
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-full h-0.5 bg-gradient-to-r from-primary/50 to-transparent" />
              )}
              <div className="relative bg-card border border-border rounded-lg p-6 hover:shadow-[var(--shadow-soft)] transition-all duration-300 flex flex-col w-full">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-4 text-primary-foreground font-bold text-xl">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed flex-1">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};